export function FieldError({ message }: { message?: string }) {
	if (!message) return null;
	return (
		<p role="alert" className="form-error">
			{message}
		</p>
	);
}
